export default function Configure($stateProvider) {
	$stateProvider.state('stocks-gestion-rapport-activite', {
		parent: 'gestion',
		url: '/stocks-gestion-rapport-activite',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.STOCKS" | translate }}'
		}
	});

	$stateProvider.state('stocks-gestion-rapport-activite.list', {
		url: '/list',
		params: {
			codeDomaineParam: null,
			labelDomaineParam: null
		},
		template: '<stocks-gestion-rapport-activite></stocks-gestion-rapport-activite>',
		rights: { right: 'read' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE" | translate}}'
		},
		navigation: {
			menu: 'stocks_no_category',
			translate: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE',
			order: 1
		},
		search: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE'
	});

	$stateProvider.state('stocks-gestion-rapport-activite.edit', {
		url: '/edit',
		params: {
			codeDomaineParam: null,
			labelDomaineParam: null
		},
		template: '<stocks-gestion-rapport-activite></stocks-gestion-rapport-activite>',
		rights: { right: 'create' },
		ncyBreadcrumb: {
			label: '{{ "STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_UPDATE" | translate}}'
		},
		navigation: {
			menu: 'stocks_no_category',
			translate: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_UPDATE',
			order: 1
		},
		search: 'STOCKS_GESTION_RAPPORT_ACTIVITE.BREADCRUMBS.STOCKS_GESTION_RAPPORT_ACTIVITE_UPDATE'
	});
}

Configure.$inject = ['$stateProvider'];
